import { createAction, createAsyncAction } from 'services/actionConfigs';
import { PREFIX_ACTIONS } from './constants';
import { ICustomServicePricesByStaff } from './types/api';

const getShopInfo = createAsyncAction<string>(PREFIX_ACTIONS + 'getShopInfo');

const get = {
  staffs: createAsyncAction<string>(PREFIX_ACTIONS + 'getStaffList'),
  staffsBookingOnline: createAsyncAction<string>(PREFIX_ACTIONS + 'getStaffsBookingOnline'),
  staffsBookingOnlineWithCustomer: createAction<string>(PREFIX_ACTIONS + 'getStaffsBookingOnlineWithCustomer'),
  categories: createAsyncAction<string>(PREFIX_ACTIONS + 'getCategories'),
  socialMedia: createAsyncAction<string>(PREFIX_ACTIONS + 'getSocialMedia'),
  quickServices: createAsyncAction<string>(PREFIX_ACTIONS + 'quickServices'),
  allSetting: createAsyncAction<string>(PREFIX_ACTIONS + 'shopAllSetting'),
  allShopSetting: createAsyncAction<string>(PREFIX_ACTIONS + 'allShopSetting'),
  notification: createAsyncAction<string>(PREFIX_ACTIONS + 'notification'),
  settingDepositBooking: createAsyncAction<string>(PREFIX_ACTIONS + 'settingDepositBooking'),
  servicesByCategory: createAsyncAction<string>(PREFIX_ACTIONS + 'servicesByCategory'),
  customServicePricesByStaff: createAsyncAction<void>(PREFIX_ACTIONS + 'customServicePricesByStaff'),
};

const init = {
  bookingOnline: createAction<string>(PREFIX_ACTIONS + 'initBookingOnline'),
  checkInOnline: createAction<string>(PREFIX_ACTIONS + 'initCheckInOnline'),
};

const shopActions = {
  getShopInfo,
  get,
  init,
};

export default shopActions;
